import { CSSProperties } from "react";

import { Exclamation as ExclamationIcon } from "@assets/svg";

const DEFAULT_SIZE = 80;

type ExclamationProps = {
  style?: CSSProperties;
  size?: number;
};

export const Exclamation = ({ style, size = DEFAULT_SIZE }: ExclamationProps) => {
  return <ExclamationIcon size={size} style={style} />;
};
